module.exports = __webpack_public_path__ + "img/presidente-tjgo.34e5f515.png";